export const FLAG_GETTING_DISCOUNT_CODE_SUB_CATEGORIES =
  'FLAG_GETTING_DISCOUNT_CODE_SUB_CATEGORIES';
export const GET_DISCOUNT_CODE_SUB_CATEGORIES =
  'GET_DISCOUNT_CODE_SUB_CATEGORIES';
export const CLEAR_DISCOUNT_CODE_SUB_CATEGORIES =
  'CLEAR_DISCOUNT_CODE_SUB_CATEGORIES';
